export const Design_Illustration = [
    "2D Design",
    "3D Design",
    "Art Direction (Advertising)",
    "Brand Design",
    "Brochure Design",
    "Corporate Identity Design",
    "Creative Direction",
    "Desktop Publishing (DTP)",
    "Graphic Design",
    "Illustration",
    "Logo Design",
    "Motion Graphics Design",
    "Multimedia Design",
    "Packaging Design",
    "Presentation Design",
    "Print Design",
    "Product Design",
    "Storyboards",
    "Textile Design",
    "UI Design",
    "UX Design",
    "UI/UX Design",
    "VFX Design (Visual Effects Design)",
    "Web Design",
    "Other"
];

export const Digital_Marketing = [
    "Brand Strategy",
    "Communications Management",
    "Community management (Social Media)",
    "Content Creation",
    "Content Design",
    "Content Editing",
    "Content Marketing Management",
    "Copy Editing",
    "Copywriting",
    "Display Advertising",
    "Digital Marketing Strategy",
    "Digital Marketing Management",
    "Email Marketing",
    "Influencer Marketing",
    "Lead Generation",
    "Marketing Strategy",
    "Public Relations",
    "Search Engine Marketing / Pay per Click Advertising",
    "SEO Consulting/SEO Strategy",
    "SEO Copywriting",
    "SEO - Search Engine Optimization",
    "Social Media Advertising",
    "Social Media Audit",
    "Social Media Management",
    "Social Media Marketing",
    "Social Media Strategy",
    "Social Media Profile Set up",
    "Social Media Analytics and Reporting",
    "Other"
];

export const Mobile_Web_Development = [
    "Android App Development",
    "Ecommerce Development",
    "ios App Development",
    "Mobile Web Development",
    "UX/UI Design",
    "Web Development",
    "Website Management/maintenance",
    "Product Manager",
    "Other"
];

export const Photography_Videography = [
    "3D Product Animation",
    "Animated Explainer Video",
    "Animated Gifs",
    "Art Direction",
    "Character Animation",
    "Corporate Video Editing",
    "Corporate Video Production",
    "Explainer Video",
    "Digital Video Production",
    "Highlights Video",
    "Film Production",
    "Logo Animation",
    "Motion Graphics",
    "Photo Editing",
    "Photography",
    "Product Photography",
    "Promo Video",
    "Social Media Videos",
    "Script Writing",
    "Video Content Creation",
    "Video Editing",
    "Videography",
    "Voice Over",
    "Visual Effects",
    "Other"
];

export const Writing_Reporting = [
    "Academic Writing",
    "Blog Writing",
    "Copy Editing",
    "Copywriting",
    "Creative writing",
    "Journalistic writing",
    "Legal Writing",
    "PR Writing",
    "Research writing",
    "Report writing",
    "Script Editing",
    "Script Writing",
    "Speech Writing",
    "Technical Writing",
    "Transcribing",
    "Web Content Writing",
    "Other"
];
